module.exports = __webpack_public_path__ + "2ef7e69d23b4349398614c71b8805437.svg";